<div class="llm-panel">
  <div class="llm-panel__head">
    <div>
      <h3 class="llm-panel__title">{{ 'Auslastung' | translate }}</h3>
      <div class="llm-panel__hint llm-usage__mock">
        {{ 'Beispieldaten – die Erfassung der Nutzungsdaten ist noch nicht aktiv' | translate }}
      </div>
    </div>
    <dx-select-box
      [items]="ranges"
      displayExpr="name"
      valueExpr="days"
      [value]="selectedRange"
      [width]="180"
      (onValueChanged)="onRangeChanged($event)"
    ></dx-select-box>
  </div>

  <div class="llm-usage__tiles" *ngIf="usage">
    <div class="llm-tile">
      <span class="llm-tile__label">{{ 'Anfragen' | translate }}</span>
      <span class="llm-tile__value">{{ usage.totalRequests | number }}</span>
    </div>
    <div class="llm-tile">
      <span class="llm-tile__label">{{ 'Kosten' | translate }}</span>
      <span class="llm-tile__value">{{ usage.totalSpend | currency:'EUR' }}</span>
    </div>
    <div class="llm-tile">
      <span class="llm-tile__label">{{ 'Fehlerquote' | translate }}</span>
      <span class="llm-tile__value" [class.llm-tile__value--warn]="usage.failureRate > 0.05">
        {{ usage.failureRate | percent:'1.1-1' }}
      </span>
    </div>
    <div class="llm-tile">
      <span class="llm-tile__label">{{ 'Eigene Zugänge' | translate }}</span>
      <span class="llm-tile__value">{{ usage.ownCredentialShare | percent }}</span>
    </div>
  </div>

  <div class="llm-usage__charts" *ngIf="usage">
    <div class="llm-usage__chart">
      <h4 class="llm-usage__chartTitle">{{ 'Anfragen pro Tag' | translate }}</h4>
      <dx-chart [dataSource]="usage.perDay" palette="Soft Blue">
        <dxi-series argumentField="day" valueField="requests" type="splinearea" name="{{ 'Anfragen' | translate }}"></dxi-series>
        <dxo-argument-axis [tickInterval]="{ days: 5 }">
          <dxo-label format="dd.MM"></dxo-label>
        </dxo-argument-axis>
        <dxo-legend [visible]="false"></dxo-legend>
        <dxo-tooltip [enabled]="true"></dxo-tooltip>
      </dx-chart>
    </div>

    <div class="llm-usage__chart">
      <h4 class="llm-usage__chartTitle">{{ 'Verteilung nach Anbieter' | translate }}</h4>
      <dx-pie-chart [dataSource]="usage.perProvider" palette="Soft Blue" type="doughnut">
        <dxi-series argumentField="provider" valueField="requests"></dxi-series>
        <dxo-legend horizontalAlignment="center" verticalAlignment="bottom"></dxo-legend>
        <dxo-tooltip [enabled]="true"></dxo-tooltip>
      </dx-pie-chart>
    </div>
  </div>

  <div class="llm-usage__table" *ngIf="usage">
    <h4 class="llm-usage__chartTitle">{{ 'Kunden mit der höchsten Auslastung' | translate }}</h4>
    <dx-data-grid
      [dataSource]="usage.topCustomers"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      [columnAutoWidth]="true"
    >
      <dxo-paging [enabled]="false"></dxo-paging>
      <dxi-column dataField="customerName" caption="{{ 'Kunde' | translate }}"></dxi-column>
      <dxi-column dataField="requests" caption="{{ 'Anfragen' | translate }}" [width]="130" format="#,##0"></dxi-column>
      <dxi-column dataField="spend" caption="{{ 'Kosten' | translate }}" [width]="130" format="#,##0.00 €"></dxi-column>
      <dxi-column dataField="ownCredentials" caption="{{ 'Eigener Zugang' | translate }}" [width]="150" cellTemplate="ownTemplate"></dxi-column>
      <div *dxTemplate="let cell of 'ownTemplate'">
        <span class="llm-badge" *ngIf="cell.value">{{ 'eigener Zugang' | translate }}</span>
        <span class="llm-muted" *ngIf="!cell.value">{{ 'über nextPIM' | translate }}</span>
      </div>
    </dx-data-grid>
  </div>
</div>
